export default "__VITE_ASSET__BXM$l6m4__"